export interface IRatePlanList {
  id: number;
  createdAt: string;
  updatedAt: string;
  name: string;
  totalSellers: number;
  taxAggregateVersion: number;
}

export enum ERatePlanReceiptType {
  TIMELINE = "TIMELINE",
  EARLY = "EARLY",
}

export enum ERatePlanTaxCreditBrand {
  default = "default",
  mastercard = "mastercard",
  visa = "visa",
  elo = "elo",
  discover = "discover",
  hipercard = "hipercard",
  american_express = "american_express",
}

export enum ERatePlanTaxCapture {
  pos = "pos",
  tap = "tap",
  online = "online",
}

export enum ERatePlanTax {
  pix = "pix",
  debit = "debit",
  credit = "credit",
  bankSlip = "bankSlip",
}

export interface IRatePlanPagination {
  page: number;
  limit: number;
  total: number;
  pages: number;
}

export interface IRatePlanWithPagination {
  data: IRatePlanList[];
  pagination: IRatePlanPagination;
}

export interface IRatePlanTaxBankSlip {
  value: number;
  rateType: string;
  valueLimit: number;
  delayForRedeem: number;
}

export interface IRatePlanTaxCreditBrand {
  sellerRates: number[];
}

export type IRatePlanTaxCreditMethod = {
  delayForRedeem: number;
} & Partial<Record<ERatePlanTaxCreditBrand, IRatePlanTaxCreditBrand>>;

export type IRatePlanTaxCredit = Partial<
  Record<ERatePlanTaxCapture, IRatePlanTaxCreditMethod>
>;

export interface IRatePlanTaxDebit {
  value: number;
  rateType: string;
  delayForRedeem: number;
}

export interface IRatePlanTaxPix {
  value: number;
  rateType: string;
  valueLimit: number;
  delayForRedeem: number;
}

export type IRatePlanTax = {
  [ERatePlanTax.pix]: IRatePlanTaxPix;
  [ERatePlanTax.debit]: IRatePlanTaxDebit;
  [ERatePlanTax.credit]: IRatePlanTaxCredit[];
  [ERatePlanTax.bankSlip]: IRatePlanTaxBankSlip;
  receiptType: keyof typeof ERatePlanReceiptType;
};

export interface IRatePlanPendencies {
  currentValue: number;
  method: keyof typeof ERatePlanTax;
  brand: keyof typeof ERatePlanTaxCreditBrand;
  captureType: keyof typeof ERatePlanTaxCapture;
  delayForRedeem: number;
  installment: number;
  consentedByUser: string;
  consentedAt: string;
}

export interface IRatePlanDetails {
  id: string;
  name: string;
  taxAggregateVersion: string;
  tax_aggregate_version: string;
  tax: IRatePlanTax;
  hasPendencies: boolean;
  pendencies: IRatePlanPendencies[];
}

export interface IRatePlanSellerList {
  id: number;
  companyName: string;
  document: string;
  idPlanCompany: number;
  idPlanSeller: number;
  idCompany: number;
}

export interface IRatePlanSellerWithPagination {
  data: IRatePlanSellerList[];
  pagination: IRatePlanPagination;
}

export enum ERatePlanHistoryStatus {
  CURRENT = "CURRENT",
  PREVIOUS = "PREVIOUS",
}

export interface IRatePlanHistoryList {
  id: number;
  startedAt: string;
  endedAt: string | null;
  description: string;
  tax: IRatePlanTax;
  createdBy: string;
}

export interface IRatePlanHistoryWithPagination {
  data: IRatePlanHistoryList[];
  pagination: IRatePlanPagination;
}

export interface IRatePlanHistoryDetail extends IRatePlanHistoryList {
  lastHistory: IRatePlanHistoryList | null;
}
